/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategories200ResponseReissueOneOf1
 */
export interface UpdateAvailableMerchantCategories200ResponseReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseReissueOneOf1
     */
    'cardType': UpdateAvailableMerchantCategories200ResponseReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200ResponseReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200ResponseReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const UpdateAvailableMerchantCategories200ResponseReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type UpdateAvailableMerchantCategories200ResponseReissueOneOf1CardTypeEnum = typeof UpdateAvailableMerchantCategories200ResponseReissueOneOf1CardTypeEnum[keyof typeof UpdateAvailableMerchantCategories200ResponseReissueOneOf1CardTypeEnum];


